import React, { useState, useEffect, useCallback, useMemo } from 'react';
import socketService from '../services/socketService';
import Layout from '../components/Layout';
import moment from 'moment-timezone';

const AppReceive = () => {
    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [pagination, setPagination] = useState({ totalPages: 1, currentPage: 1, totalRows: 0 });

    const isMasterAdmin = localStorage.getItem('isMaster') === 'true';

  const [filters, setFilters] = useState({
        username: '', 
        devicename: '',     // নতুন যোগ হলো
        searchMessage: '',  // নতুন যোগ হলো
        simno: '', 
        seenBy: '', 
        start_date: '', 
        end_date: '', 
        page: 1
    });

    // লোগো খুঁজে বের করার ফাংশন
    const getSenderLogo = (sender) => {
        if (!sender) return '/logo.png'; 
        const sLower = sender.toLowerCase();
        
        if (sLower.includes('bkash')) return '/bkash.jpg';
        if (sLower.includes('nagad')) return '/nagad.png';
        if (sLower.includes('rocket')) return '/rocket.png';
        if (sLower.includes('whatsapp')) return '/whatsapp.png';
        
        return '/logo.png'; 
    };

  // ==============================================================
    // 🔥 Updated fetchData (Role-Based Access Control)
    // ==============================================================
    const fetchData = useCallback(() => {
        setLoading(true);

        // LocalStorage থেকে অথেনটিকেশন এবং পারমিশন ডাটা নিয়ে আসা
        const isMaster = localStorage.getItem('isMaster');
        let allowedUsers = [];
        try {
            const stored = localStorage.getItem('allowedUsers');
            allowedUsers = stored ? JSON.parse(stored) : [];
        } catch (e) {
            allowedUsers = [];
        }

        // ফিল্টারের সাথে isMaster এবং allowedUsers যুক্ত করে সার্ভারে পাঠানো
        const payload = {
            ...filters,
            isMaster,
            allowedUsers
        };

        socketService.emit('fetch_alternative_sms_logs', payload);
    }, [filters]);

    useEffect(() => {
        socketService.connect();

        socketService.on('receive_alternative_sms_logs', (data) => {
            setLogs(data.logs);
            setPagination({ 
                totalPages: data.totalPages, 
                currentPage: data.currentPage, 
                totalRows: data.totalRows 
            });
            setLoading(false);
        });

        fetchData();

        return () => {
            socketService.off('receive_alternative_sms_logs');
        };
    }, [fetchData]);

    const handleFilterChange = (e) => {
        setFilters({ ...filters, [e.target.name]: e.target.value, page: 1 });
    };

    const handleReset = () => {
        setFilters({ username: '', simno: '', seenBy: '', start_date: '', end_date: '', page: 1 });
    };
    
    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= pagination.totalPages) {
            setFilters(prev => ({ ...prev, page: newPage }));
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };

    // 🔥 NEW: মেসেজ থেকে টাকার পরিমাণ বের করে যোগ করার লজিক
    const totalAmount = useMemo(() => {
        return logs.reduce((acc, log) => {
            if (!log.message) return acc;

            // রেগুলার এক্সপ্রেশন: Amount, Tk, ৳ বা BDT এর পরে সংখ্যা খুঁজবে
            const match = log.message.match(/(?:Amount|Tk|৳|BDT)\s*[:.\-]?\s*([\d,]+\.?\d*)/i);
            
            if (match && match[1]) {
                // কমা (,) সরিয়ে সংখ্যায় রূপান্তর
                const amount = parseFloat(match[1].replace(/,/g, ''));
                return acc + (isNaN(amount) ? 0 : amount);
            }
            return acc;
        }, 0);
    }, [logs]);

    return (
        <Layout>
            <div className="main-content-area py-3 px-10">
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <h5 className="section-title m-0">📋 App Receive Logs</h5>
                    
                    {/* 🔥 MODIFIED: Total Records এবং Total Amount একসাথে দেখানো হচ্ছে */}
                    <div className="d-flex gap-3">
                        <div className="count-badge">
                            Total Records: <span>{pagination.totalRows}</span>
                        </div>
                        <div className="count-badge" style={{ borderColor: '#16a34a', background: '#f0fdf4' }}>
                            Page Total: <span style={{ color: '#16a34a' }}>
                                ৳{new Intl.NumberFormat('en-BD', { minimumFractionDigits: 2 }).format(totalAmount)}
                            </span>
                        </div>
                    </div>
                </div>

                {/* Filter Section */}
                <div className="filter-card shadow-sm border-0 mb-4">
                    <div className="row g-2 align-items-end">
                       {/* --- Username বা Device Name ফিল্টার --- */}
                            {isMasterAdmin ? (
                                <div className="col-md-2 col-sm-6">
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        name="username" 
                                        placeholder="👤 Search Username..." 
                                        value={filters.username} 
                                        onChange={handleFilterChange} 
                                    />
                                </div>
                            ) : (
                                <div className="col-md-2 col-sm-6">
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        name="devicename" 
                                        placeholder="📱 Search Device Name..." 
                                        value={filters.devicename} 
                                        onChange={handleFilterChange} 
                                    />
                                </div>
                            )}

                            {/* --- নতুন: Message Content Search --- */}
                            <div className="col-md-3 col-sm-6">
                                <input 
                                    type="text" 
                                    className="form-control border-primary shadow-sm" 
                                    name="searchMessage" 
                                    placeholder="💬 Search in message..." 
                                    value={filters.searchMessage} 
                                    onChange={handleFilterChange} 
                                />
                            </div>
                        <div className="col-md-2">
                            <label className="field-label">SIM NO</label>
                            <input type="text" name="simno" className="modern-input" placeholder="SIM Number" value={filters.simno} onChange={handleFilterChange} />
                        </div>
                        <div className="col-md-2">
                            <label className="field-label">SEEN BY</label>
                            <input type="text" name="seenBy" className="modern-input" placeholder="Seen by..." value={filters.seenBy} onChange={handleFilterChange} />
                        </div>
                        <div className="col-md-2">
                            <label className="field-label">START DATE</label>
                            <input type="date" name="start_date" className="modern-input" value={filters.start_date} onChange={handleFilterChange} />
                        </div>
                        <div className="col-md-2">
                            <label className="field-label">END DATE</label>
                            <input type="date" name="end_date" className="modern-input" value={filters.end_date} onChange={handleFilterChange} />
                        </div>
                        <div className="col-md-2 d-flex gap-1">
                            <button className="btn btn-apply fw-bold w-100" onClick={fetchData}>
                                {loading ? '...' : 'Filter'}
                            </button>
                            <button className="btn btn-reset fw-bold w-100" onClick={handleReset}>Reset</button>
                        </div>
                    </div>
                </div>

                {/* Table Section */}
                <div className="table-container shadow-sm border-0 mb-2">
                    <div className="table-responsive">
                        <table className="custom-zebra-table">
                            <thead>
                                <tr>
                                    <th className="ps-4">USER & DEVICE</th>
                                    <th>SIM & SENDER</th>
                                    <th style={{ minWidth: '350px' }}>MESSAGE CONTENT</th>
                                    <th>DATE & TIME</th>
                                    <th className="text-center">STATUS</th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr><td colSpan="5" className="text-center py-5">
                                        <div className="spinner-border spinner-border-sm text-primary me-2"></div>
                                        ডাটা লোড হচ্ছে...
                                    </td></tr>
                                ) : logs.length > 0 ? logs.map((log) => (
                                    <tr key={log._id}>
                                        <td className="ps-4">
                                            <div className="user-primary">{log.userId?.username || 'N/A'}</div>
                                            <div className="device-secondary text-uppercase">{log.deviceName || 'Unknown'}</div>
                                        </td>
                                        
                                        <td>
                                            <div className="d-flex align-items-center">
                                                <img 
                                                    src={getSenderLogo(log.senderID)} 
                                                    alt="logo" 
                                                    style={{
                                                        width: '32px', 
                                                        height: '32px', 
                                                        borderRadius: '50%', 
                                                        marginRight: '10px',
                                                        border: '1px solid #e2e8f0',
                                                        padding: '2px',
                                                        objectFit: 'contain',
                                                        background: '#fff'
                                                    }} 
                                                />
                                                <div>
                                                    <div className="sim-num">{log.simno}</div>
                                                    <div className="sender-tag">{log.senderID}</div>
                                                    {log.operator && <small className="d-block text-muted" style={{fontSize: '10px'}}>{log.operator}</small>}
                                                </div>
                                            </div>
                                        </td>

                                        <td className="msg-body py-3">{log.message}</td>
                                        <td>
                                            <div className="date-bold">{moment(log.receivedAt).tz('Asia/Dhaka').format('DD MMM, YYYY')}</div>
                                            <div className="time-muted">{moment(log.receivedAt).tz('Asia/Dhaka').format('hh:mm A')}</div>
                                        </td>
                                        <td className="text-center">
                                            {log.seenBy ? (
                                                <span className="badge-seen" title={`Seen by ${log.seenBy}`}>
                                                    {log.seenBy} ✅
                                                </span>
                                            ) : (
                                                <span className="badge-unseen">Unseen</span>
                                            )}
                                        </td>
                                    </tr>
                                )) : (
                                    <tr><td colSpan="5" className="text-center py-4 text-muted">কোনো রেকর্ড খুঁজে পাওয়া যায়নি।</td></tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* Pagination Section */}
                {pagination.totalPages > 1 && (
                    <div className="d-flex justify-content-between align-items-center px-2 py-2">
                        <div className="text-muted small">Showing Page <b>{pagination.currentPage}</b> of <b>{pagination.totalPages}</b></div>
                        <nav>
                            <ul className="pagination pagination-sm m-0 gap-1">
                                <li className={`page-item ${pagination.currentPage === 1 ? 'disabled' : ''}`}>
                                    <button className="page-link shadow-none" onClick={() => handlePageChange(pagination.currentPage - 1)}>Prev</button>
                                </li>

                                {(() => {
                                    let pages = [];
                                    const maxVisible = 7;
                                    let start = Math.max(1, pagination.currentPage - Math.floor(maxVisible / 2));
                                    let end = Math.min(pagination.totalPages, start + maxVisible - 1);

                                    if (end - start + 1 < maxVisible) {
                                        start = Math.max(1, end - maxVisible + 1);
                                    }

                                    for (let i = start; i <= end; i++) {
                                        pages.push(
                                            <li key={i} className={`page-item ${pagination.currentPage === i ? 'active' : ''}`}>
                                                <button className="page-link shadow-none" onClick={() => handlePageChange(i)}>{i}</button>
                                            </li>
                                        );
                                    }
                                    return pages;
                                })()}

                                <li className={`page-item ${pagination.currentPage === pagination.totalPages ? 'disabled' : ''}`}>
                                    <button className="page-link shadow-none" onClick={() => handlePageChange(pagination.currentPage + 1)}>Next</button>
                                </li>
                            </ul>
                        </nav>
                    </div>
                )}
            </div>

            <style>{`
                .main-content-area { background-color: #f4f7fa; min-height: 100vh; font-family: 'Inter', sans-serif; }
                .section-title { color: #0d6efd; font-weight: 700; }
                .count-badge { background: #fff; padding: 5px 15px; border-radius: 50px; border: 1px solid #e2e8f0; font-size: 13px; font-weight: 600; }
                .count-badge span { color: #0d6efd; font-weight: 800; }
                .filter-card { background: #ffffff; padding: 20px; border-radius: 12px; }
                .field-label { font-size: 11px; font-weight: 700; color: #64748b; margin-bottom: 5px; text-transform: uppercase; }
                .modern-input { background: #f8fafc; border: 1px solid #cbd5e1; padding: 8px 12px; border-radius: 8px; font-size: 13px; width: 100%; outline: none; transition: 0.2s; }
                .modern-input:focus { border-color: #0d6efd; box-shadow: 0 0 0 2px rgba(13,110,253,0.1); }
                .btn-apply { background: #0d6efd; color: white; border-radius: 8px; font-size: 13px; border: none; transition: 0.3s; }
                .btn-apply:hover { background: #0a58ca; }
                .btn-reset { background: #f1f5f9; color: #475569; border: 1px solid #cbd5e1; border-radius: 8px; font-size: 13px; transition: 0.3s; }
                .btn-reset:hover { background: #e2e8f0; }
                .table-container { background: #ffffff; border-radius: 12px; overflow: hidden; }
                .custom-zebra-table { width: 100%; border-collapse: collapse; }
                .custom-zebra-table thead { background: #f1f5f9; color: #475569; }
                .custom-zebra-table th { padding: 14px 15px; font-size: 11px; font-weight: 800; text-transform: uppercase; border-bottom: 2px solid #e2e8f0; }
                .custom-zebra-table tbody tr:hover { background-color: #f1f5f9; transition: 0.2s; }
                .custom-zebra-table tbody tr:nth-child(even) { background-color: #f8fafc; }
                .custom-zebra-table td { padding: 12px 15px; vertical-align: middle; border-bottom: 1px solid #edf2f7; }
                .user-primary { color: #0d6efd; font-weight: 700; font-size: 14px; }
                .device-secondary { font-size: 10px; color: #64748b; font-weight: 800; background: #e2e8f0; display: inline-block; padding: 1px 6px; border-radius: 4px; margin-top: 3px; }
                .sim-num { color: #1e293b; font-weight: 600; font-size: 13px; }
                .sender-tag { color: #6366f1; font-weight: 800; font-size: 11px; }
                .msg-body { color: #334155; font-size: 13px; line-height: 1.5; white-space: pre-wrap; word-break: break-all; }
                .date-bold { color: #334155; font-weight: 700; font-size: 13px; }
                .time-muted { font-size: 11px; color: #64748b; }
                .badge-seen { background: #f0fdf4; color: #16a34a; padding: 4px 12px; border-radius: 6px; font-size: 11px; font-weight: 700; border: 1px solid #bbf7d0; display: inline-block; }
                .badge-unseen { background: #fff7ed; color: #ea580c; padding: 4px 12px; border-radius: 6px; font-size: 11px; font-weight: 700; border: 1px solid #ffedd5; display: inline-block; }
                .page-link { color: #475569; border: 1px solid #e2e8f0; border-radius: 6px !important; cursor: pointer; padding: 5px 12px; }
                .page-item.active .page-link { background-color: #0d6efd; color: white; border-color: #0d6efd; }
                .page-item.disabled .page-link { background-color: #f8fafc; color: #cbd5e1; }
            `}</style>
        </Layout>
    );
};

export default AppReceive;